import { useEffect, useState } from "react";
import styles from "./InputNumber.module.css";

function InputNumber({ text, unit, onChange, firstValue, isDisabled }) {
  const [value, setValue] = useState(firstValue);

  function decimalValidate(event) {
    const inputValue = event.target.value;
    // Regex para permitir apenas números com até duas casas decimais
    if (/^\d*\.?\d{0,2}$/.test(inputValue)) {
      setValue(inputValue);
      onChange(event);
    }
  }

  useEffect(() => {
    setValue(firstValue);
  }, [firstValue]);

  return (
    <form className={styles.inputNumberComponent}>
      <label className={styles.componentText}>{text} =</label>
      <input
        className={styles.componentInput}
        value={value}
        onChange={decimalValidate}
        inputMode="decimal"
        disabled={isDisabled}
      ></input>
      <label className={styles.componentUnit}>{unit ? unit : ""}</label>
    </form>
  );
}

export default InputNumber;
